import { usePricelistSalesChannelDeleteMutation } from "@/generated/graphql";

export const usePricelistSalesChannelDelete = () => {
	const [, remove] = usePricelistSalesChannelDeleteMutation();

	const deletePricelistSalesChannel = (pricelistSalesChannelID: string) => {
		return remove({ pricelistSalesChannelID });
	};

	return {
		deletePricelistSalesChannel,
	};
};
